import React from "react";

import { Button, Modal } from "antd";
import "./DeleteInvite.css";

export default function DeleteInvite({ handleDeleteModal, handleDeleteInvite, loadingData }) {
  return (
    <Modal
      open
      closable={false}
      centered
      footer={null}
      onCancel={() => handleDeleteModal(false)}
      width="448px"
      wrapClassName="DeleteInviteModel"
      className="DeleteInviteModelContainer"
    >
      <div className="DeleteInviteModel">
        <div
          className="DeleteInviteModelHeader"
        >
          Delete User
        </div>
        <div
          className="DeleteInviteModelText"
        >
          The invited user will not be able submit submissions. Are you sure you want to proceed?
        </div>
        <div className="DeleteInviteModelBtns">
          <Button
            type="default"
            onClick={() => handleDeleteModal(false)}
          >
            Cancel
          </Button>
          <Button
            type="primary"
            onClick={() => handleDeleteInvite()}
            loading={loadingData}
          >
            Delete
          </Button>
        </div>
      </div>
    </Modal>
  );
}
